<template>
  <div class="booking-list">
    <div class="booking-division" />

    <div class="booking-header-search">
      <form action="/">
        <van-search
          v-model="searchForm.value"
          placeholder="支持客户姓名&手机号&套餐名称模糊搜索"
          @search="onSearch"
          show-action
        >
          <template #action>
            <div @click="onSearch(searchForm.value)">搜索</div>
          </template>
        </van-search>
      </form>
    </div>
    <div class="booking-division" />
    <div
      v-if="currentUserInfo.user_id"
      class="booking-list-main"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >

        <div
          class="booking-list-item"
          v-for="item in orderList"
          :key="item.id"
        >
          <div class="booking-list-item-option">
            <div>
              预约单号
            </div>
            <div v-show="item.neijing_work_id || item.tijian_work_id">
              <van-badge
                :dot="item.message_list.some(item => item.from_type == 'doctor' && !item.is_read)"
                color="#da0032"
              >
                <el-button
                  type="danger"
                  size="mini"
                  @click="goPage({
                    name: 'BookingMessage',
                    item,
                  })"
                >消息</el-button>
              </van-badge>
              <el-button
                type="danger"
                size="mini"
                @click="goPage({
                  name: 'BookingManagement',
                  item,
                })"
              >修改</el-button>
            </div>
          </div>
          <div
            class="booking-list-item-option"
            v-if="item.puke_his_booking_status"
          >
            <div>
              预约时间 {{ item.puke_his_booking_status != 3 ? item.bookingTime : '' }}
            </div>
            <div>
              <el-button
                type="text"
                :class="item.puke_his_booking_status == 3 ? 'booking-list-btn-disabled' : ''"
                @click="cancelReservation(item)"
              >取消</el-button>
              <el-button
                type="text"
                :class="item.puke_his_booking_status == 3 ? 'booking-list-btn-disabled' : ''"
                @click="changeAppointment(item)"
              >改约</el-button>
            </div>
          </div>
          <div class="booking-list-item-more">
            <p
              v-if="item.neijing_work_id"
              @click="goOrderDetail(item.neijing_work_id)"
            >
              内镜工单 {{ item.neijing_work_id }}
            </p>
            <p
              v-if="item.tijian_work_id"
              @click="goOrderDetail(item.tijian_work_id)"
            >
              高客体检工单 {{ item.tijian_work_id }}
            </p>
            <p
              v-if="item.waisong_work_id"
              @click="goOrderDetail(item.waisong_work_id)"
            >
              瑞金医院检查预约 {{ item.waisong_work_id }}
            </p>
          </div>
          <div class="booking-list-item-option">
            <div>
              客户信息
            </div>
            <div>
              {{ item.customer_name }} {{ item.customer_mobile2 }}
            </div>
          </div>
          <div class="booking-list-item-option">
            <div>
              产品名称
            </div>
            <div>
              {{ item.product_name }}
            </div>
          </div>
          <div class="booking-division" />

        </div>
      </van-list>

    </div>
    <van-popup
      v-model="showCancelPopup"
      position="bottom"
    >
      <div class="booking-home-search">
        <div class="booking-home-search-header">
          <div @click="showCancelPopup = false">
            取消
          </div>
          <div
            class="booking-submit"
            @click="cancelConfirm"
          >
            确定
          </div>
        </div>
        <div class="booking-division" />

        <div class="booking-list-cancel">
          <van-form>
            <van-field
              readonly
              clickable
              name="picker"
              :value="cancelForm.reason"
              label="取消原因"
              placeholder="点击选择取消原因"
              @click="showPicker = true"
            />
            <van-popup
              v-model="showPicker"
              position="bottom"
            >
              <van-picker
                show-toolbar
                :columns="columns"
                @cancel="showPicker = false"
                @confirm="cancelReasonConfirm"
              />
            </van-popup>
            <van-field
              name="checkbox"
              label="发送取消短信"
            >
              <template #input>
                <van-switch
                  :active-value="1"
                  :inactive-value="0"
                  v-model="cancelForm.is_send_msg"
                  size="20"
                />

              </template>
            </van-field>

          </van-form>
        </div>
      </div>
    </van-popup>
    <van-overlay
      :show="submiting"
      z-index="9999"
    >
      <van-loading type="spinner" />
    </van-overlay>
  </div>
</template>

<script>
import bookingService from "@/apis/booking";
import getUserInfo from "@/models/userInfo";
import moment from "moment";
import { Toast } from "vant";
// import { deepClone } from "@/utils/utils";

export default {
  data() {
    return {
      submiting: false,
      showCancelPopup: false,
      cancelForm: {
        is_send_msg: 1,
      },
      columns: [
        "客户计划有变",
        "身体状况延期",
        "工作原因延期",
        "接种其他疫苗",
        "疫情影响",
        "其他",
      ],
      showPicker: false,

      searchForm: {},
      currentUserInfo: {},
      orderList: [],
      loading: false,
      finished: false,
      pageInfo: {
        page_index: 0,
        page_size: 20,
      },
      currentApplyInfo: null,
    };
  },
  async created() {
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    // this.getApplyList();
  },
  methods: {
    cancelReasonConfirm(value) {
      const { cancelForm } = this;
      cancelForm.reason = value;
      this.showPicker = false;
    },
    cancelConfirm() {
      const { cancelForm, currentApplyInfo, currentUserInfo } = this;
      let errMsg = "";
      if (!cancelForm.reason) {
        errMsg = "请选择取消原因";
      }
      if (errMsg) {
        Toast(errMsg);
        return;
      }
      const params = {
        apply_id: currentApplyInfo.id,
        is_all: 0,
        is_puke: 1,
        puke_cancel_reason: cancelForm.reason,
        is_send_msg: cancelForm.is_send_msg,
        work_id: 0,
        SubmitUserId: currentUserInfo.user_id,
        SubmitUser: currentUserInfo.user_id,
      };
      this.submiting = true;
      bookingService
        .bookReservationCancel(params)
        .then(() => {
          currentApplyInfo.puke_his_booking_status = 3;
          currentApplyInfo.puke_his_booking_id = 0;
          currentApplyInfo.bookingTime = null;
          this.$forceUpdate();
          Toast("取消预约成功");
          this.showCancelPopup = false;
          this.submiting = false;
        })
        .catch(() => {
          this.submiting = false;
        });
    },
    changeAppointment(item) {
      if (item.puke_his_booking_status == 3) {
        Toast("该预约单已取消");
        return;
      }
      this.$router.push({
        name: "BookingPlan",
        query: {
          his_package_id: item.his_package_id,
          apply_id: item.id,
          is_all: 0,
          is_puke: 1,
          work_id: 0,
          // neijingItemID: bookingInfo.neijingItemID,
          // waiSongItemID: bookingInfo.waiSongItemID,
          // his_package_id: bookingInfo.his_package_id,
          // isCheckup: bookingInfo.isCheckup,
        },
      });
    },
    cancelReservation(item) {
      if (item.puke_his_booking_status == 3) {
        Toast("该预约单已取消");
        return;
      }
      this.currentApplyInfo = item;
      this.cancelForm = {
        is_send_msg: 1,
      };
      this.showCancelPopup = true;
    },
    showMore(item) {
      item.showMore = !item.showMore;
      this.orderList = [...this.orderList];
    },
    onSearch(query) {
      this.orderList = [];
      this.pageInfo.page_index = 1;
      this.getApplyList(query);
    },
    onLoad() {
      this.pageInfo.page_index++;
      this.getApplyList();
    },
    getApplyList(query = "") {
      const { currentUserInfo, pageInfo } = this;
      const params = {
        submit_user_id: currentUserInfo.user_id,
        keyword: query,
        page_index: pageInfo.page_index,
        page_size: pageInfo.page_size,
      };

      bookingService
        .applyList(params)
        .then((res) => {
          this.loading = false;
          if (res.page_index * res.page_size > res.total_record_count) {
            this.finished = true;
          }
          res.data.forEach((item) => {
            if (item.puke_his_booking_status) {
              item.bookingTime = `${moment(item.his_booking_time).format(
                "YYYY-MM-DD"
              )} ${item.his_booking_begintime}-${item.his_booking_endtime}`;
            }
          });

          this.orderList.push(...res.data);
        })
        .catch(() => {
          this.pageInfo.page_index--;
          this.loading = false;
        });
    },
    goPage({ name, item }) {
      this.$router.push({
        name: name,
        query: {
          his_package_id: item.his_package_id,
          id: item.id,
        },
      });
    },
    goOrderDetail(workId) {
      this.$router.push({
        name: "WorkOrderDetail",
        query: {
          id: workId,
          type: "normal",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-list-btn-disabled {
  color: #c0c4cc;
}
.booking-list-item {
  .booking-list-item-option {
    display: flex;
    justify-content: space-between;
    padding: 15px 20px;

    border-bottom: 1px solid rgba(0, 48, 87, 0.1);
    div {
      word-break: break-all;
    }
    div:nth-child(1) {
      flex-shrink: 0;
    }
    div:nth-child(2) {
      text-align: right;
    }
    .el-button {
      margin-left: 10px;
    }
  }
  .booking-list-item-more {
    padding: 0 20px;
    p {
      background: #eaeaea;
      margin: 0;
      padding: 7.5px 20px;

      font-size: 15px;
      color: #da0032;
      cursor: pointer;
    }
  }
  .el-button--text {
    padding-top: 2px;
    padding-bottom: 2px;
  }
}
</style>